import React from "react";
import ReminderHistoryLog from "./ReminderHistoryLog";
import CustomTable from "components/common/table/CustomTable";
import { DEFAULT_PAGE_SIZE_OPTIONS } from "static/pagination";
import { setReminderHistoryPatient } from "app/store/nonCompliantPatient/slice/nonCompliantPatientSlice";
import NonCompliantPatientToolbar from "components/pages/nonCompliantPatients/toolbar/NonCompliantPatientToolbar";
import useNonCompliantPatientsTable from "components/pages/nonCompliantPatients/hooks/useNonCompliantPatientsTable";

const NonCompliantPatientsTable = () => {
  const {
    data,
    columns,
    sorting,
    expanded,
    isLoading,
    isFetching,
    pagination,
    columnFilters,
    containerWidth,
    tableContainerRef,
    dispatch,
    setSorting,
    setExpanded,
    setPagination,
    setColumnFilters,
  } = useNonCompliantPatientsTable();

  return (
    <CustomTable
      columns={columns}
      data={data?.patients || []}
      options={{
        enableSorting: true,
        enableTopToolbar: true,
        enableStickyHeader: true,
        enableRowSelection: false,
        manualSorting: true,
        manualFiltering: true,
        manualPagination: true,
        rowCount: data?.meta?.total || 0,
        onSortingChange: setSorting,
        onPaginationChange: setPagination,
        onColumnFiltersChange: setColumnFilters,
        rowsPerPageOptions: DEFAULT_PAGE_SIZE_OPTIONS,
        defaultColumn: {
          size: 180,
          minSize: 20,
          maxSize: 9001,
        },
        state: {
          sorting,
          pagination,
          columnFilters,
          showGlobalFilter: false,
          showColumnFilters: true,
          isLoading: isLoading || isFetching,
          expanded,
        },
        muiTableBodyRowProps: ({ row, table }) => ({
          onClick: () => {
            setExpanded((prev) => ({
              [row.id]: !prev[row.id],
            }));

            const rowData = row?.original;
            dispatch(setReminderHistoryPatient(rowData));
          },
          sx: {
            cursor: "pointer",
            zIndex: "0 !important",
            "td:nth-of-type(3)": {
              paddingLeft: "16px",
              paddingRight: "16px",
            },
            "td:nth-of-type(3):hover": {
              background: "rgba(0, 0, 0, 0.05)",
            },
          },
        }),
        muiTableProps: {
          sx: {
            borderSpacing: 0,
            borderCollapse: "collapse",
          },
        },
        muiTableContainerProps: {
          ref: tableContainerRef,
          sx: {
            flex: 1,
            overflowX: "auto",
            maxHeight: "100%",
          },
        },
        renderTopToolbar: ({ table }) => (
          <NonCompliantPatientToolbar table={table} />
        ),
        muiExpandButtonProps: ({ row }) => ({
          onClick: (e) => {
            e.stopPropagation();
            setExpanded((prev) => ({
              [row.id]: !prev[row.id],
            }));
            const rowData = row?.original;
            dispatch(setReminderHistoryPatient(rowData));
          },
          sx: {
            padding: "12px",
            minWidth: "48px",
            minHeight: "48px",
          },
        }),
        muiDetailPanelProps: {
          sx: {
            position: "sticky",
            left: 0,
            zIndex: 5,
            backgroundColor: "#fff",
            padding: 0,
            margin: 0,
            border: 0,
            width: containerWidth,
            maxWidth: "100%",
            boxSizing: "border-box",
            display: "table-cell",
            "&:empty": {
              display: "none",
            },
          },
        },
        renderDetailPanel: ({ row }) => {
          const rowData = row?.original;
          return (
            <div
              style={{
                width: "100%",
                maxWidth: "94vw", // make sure it fits the container width
                overflowX: "hidden", // disable horizontal scroll
              }}
            >
              <ReminderHistoryLog rowData={rowData} />
            </div>
          );
        },
      }}
    />
  );
};

export default NonCompliantPatientsTable;
